import { applicationUserProfileModel, baseEntityModel } from '.';
import { TXT_ADMIN, TXT_GUEST, TXT_OPERATOR } from '../../../../shared/translations';

export const SecurityRolesValues = ['ADMIN', 'USER', 'GUEST'] as const;
export type SecurityRoles = typeof SecurityRolesValues[number];

export const ApplicationUserScopes = ['CORE', 'VESSEL_PORTAL'] as const;
export type ApplicationUserScope = typeof ApplicationUserScopes[number];

export interface applicationUserModel extends baseEntityModel {
  username?: string;
  securityRole?: SecurityRoles;
  isEnabled?: boolean;
  profile?: applicationUserProfileModel;
  hasMicrosoftAccountConnected?: boolean;
  allowVesselTracker?: boolean;
  allowOCR?: boolean;
  scope?: ApplicationUserScope;
}

export const SecurityRoleTranslations: Record<SecurityRoles, string> = {
  ADMIN: TXT_ADMIN,
  USER: TXT_OPERATOR,
  GUEST: TXT_GUEST
};
